import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Button } from './ui/button';
import { Clock, CreditCard } from 'lucide-react';

export default function TrialBanner() {
  const navigate = useNavigate();
  const { user, getTrialDaysRemaining } = useAuth();
  
  const trialDays = getTrialDaysRemaining();
  const isOnTrial = user?.subscription_status === 'trial' && trialDays !== null;
  
  if (!isOnTrial) return null;
  
  return (
    <div 
      className="bg-gradient-to-r from-bronze/90 to-bronze text-white py-2 px-4 text-center text-sm sticky top-0 z-50" 
      data-testid="trial-banner"
    >
      <Clock className="w-4 h-4 inline mr-2" />
      <span className="font-medium">
        {trialDays > 0 
          ? `${trialDays} day${trialDays === 1 ? '' : 's'} left in your free trial`
          : 'Your trial ends today'}
      </span>
      <Button 
        variant="secondary" 
        size="sm" 
        className="ml-2 sm:ml-4 h-7 text-xs bg-white text-bronze hover:bg-white/90"
        onClick={() => navigate('/subscribe')}
        data-testid="upgrade-btn"
      >
        <CreditCard className="w-3 h-3 sm:mr-1" />
        <span className="hidden sm:inline">Upgrade Now</span>
        <span className="sm:hidden">Upgrade</span>
      </Button>
    </div>
  );
}
